import type { AccountAddress } from "@aptos-labs/ts-sdk";
import { type FetchQueryOptions, useQuery } from "@tanstack/react-query";

import { readDexSdk } from "../dex-sdk";

export interface GetAccountTriggerResetMintTsArgs {
  accountAddr: string | AccountAddress;
  enabled?: boolean;
}

export function accountTriggerResetMintTsQueryKey({
  accountAddr,
}: GetAccountTriggerResetMintTsArgs) {
  return ["accountTriggerResetMintTs", accountAddr] as const;
}

export function accountTriggerResetMintTsQuery({ accountAddr }: GetAccountTriggerResetMintTsArgs) {
  return {
    queryKey: accountTriggerResetMintTsQueryKey({ accountAddr }),
    queryFn: async () => {
      return await readDexSdk.getAccountTriggerResetMintTs(accountAddr);
    },
  } satisfies FetchQueryOptions;
}

/**
 * Query to get the timestamp when the account-specific restricted mint limits reset (in seconds).
 *
 * @remarks This query is temporary and only for use in testnet. The restricted_mint_daily_reset_timestamp_for
 * view function is a testnet-only feature and should be removed before mainnet deployment.
 */
export function useAccountTriggerResetMintTs(args: GetAccountTriggerResetMintTsArgs) {
  return useQuery({
    ...accountTriggerResetMintTsQuery(args),
    enabled: (args.enabled ?? true) && !!args.accountAddr,
  });
}
